import {
    Country,
    AppLocale,
    IsoLanguageCode,
    Locale,
} from '@superbet-group/web.types';
import {
    getCookie,
    setCookie,
} from '@app/utils/cookieHelpers';
import { setIsPrerender } from '@app/shared/featureFlags/prerender';
import { getPathLocale } from '@app/utils/locale';

export const localeMap: Record<Locale, AppLocale> = {
    [Locale.Romanian]: {
        locale: Locale.Romanian,
        localeNumberOverride: Locale.English,
        languageCode: IsoLanguageCode.Romania,
    },
    [Locale.Polish]: {
        locale: Locale.Polish,
        localeNumberOverride: Locale.English,
        languageCode: IsoLanguageCode.Poland,
    },
    [Locale.English]: {
        locale: Locale.English,
        localeNumberOverride: Locale.English,
        languageCode: IsoLanguageCode.England,
    },
    [Locale.Serbian]: {
        locale: Locale.Serbian,
        localeNumberOverride: Locale.Serbian,
        languageCode: IsoLanguageCode.Serbian,
    },
    [Locale.EnglishBelgian]: {
        locale: Locale.EnglishBelgian,
        localeNumberOverride: Locale.English,
        languageCode: IsoLanguageCode.England,
    },
    [Locale.DutchBelgian]: {
        locale: Locale.DutchBelgian,
        localeNumberOverride: Locale.DutchBelgian, // english on purpose, as we want "." decimal separator instead of ","
        languageCode: IsoLanguageCode.Dutch,
    },
    [Locale.FrenchBelgian]: {
        locale: Locale.FrenchBelgian,
        localeNumberOverride: Locale.FrenchBelgian,
        languageCode: IsoLanguageCode.French,
    },
    [Locale.PortugueseBrazilian]: {
        locale: Locale.PortugueseBrazilian,
        localeNumberOverride: Locale.PortugueseBrazilian,
        languageCode: IsoLanguageCode.Portuguese,
    },
    [Locale.EnglishBrazilian]: {
        locale: Locale.EnglishBrazilian,
        localeNumberOverride: Locale.EnglishBrazilian,
        languageCode: IsoLanguageCode.England,
    },
    [Locale.Bulgarian]: {
        locale: Locale.Bulgarian,
        localeNumberOverride: Locale.English,
        languageCode: IsoLanguageCode.Bulgarian,
    },
};

export function getAppLocale(staticLocale?: Locale): AppLocale {
    if (staticLocale) {
        return localeMap[staticLocale];
    } else {
        const superbetLocale = getCookie('superbetLocale');

        let locale: Locale;
        if (!superbetLocale) {
            // This can't happen for customers! Only prerender and local dev doesn't have the cookie
            // Check prerender.ts for more details
            const targetLocales = {
                [Country.Be]: [
                    Locale.EnglishBelgian,
                    Locale.FrenchBelgian,
                    Locale.DutchBelgian,
                ],
                [Country.Com]: [
                    Locale.EnglishBrazilian,
                ],
                [Country.Br]: [
                    Locale.EnglishBrazilian,
                    Locale.PortugueseBrazilian,
                ],
                [Country.BrSocial]: [
                    Locale.EnglishBrazilian,
                    Locale.PortugueseBrazilian,
                ],
            }[process.env.COUNTRY as string] as Locale[];
            const defaultLocale = {
                [Country.Be]: Locale.EnglishBelgian,
                [Country.Com]: Locale.EnglishBrazilian,
                [Country.Br]: Locale.PortugueseBrazilian,
                [Country.BrSocial]: Locale.PortugueseBrazilian,
            }[process.env.COUNTRY as string] as Locale;
            locale = getPathLocale(
                window.location.pathname,
                targetLocales,
                defaultLocale,
            );
            setIsPrerender(true);
        } else {
            locale = superbetLocale as Locale;
        }

        // Because Chrome has 400 days expire limitation
        setCookie(
            'superbetLocale',
            locale,
            400,
        );

        return localeMap[locale];
    }
}

export const appLocale = getAppLocale(process.env.LOCALE as Locale);
document.documentElement.lang = appLocale.locale.toLowerCase();
